module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/kaumobile1_fc4bd6a34515d27cabbe9391f0f5b4af.png";